// Le film de 30 secondes (public/media/vsl.mp4), dans un cadre de verre clair
// posé sur le ciel du hero.
//
// Avant le clic, on ne montre PAS la vignette de la vidéo (un pavé presque
// noir qui cassait le ciel) : une couverture claire — le ciel flouté, le
// téléphone verrouillé à 02:47, le bouton de lecture. Rien ne se charge avant
// le clic (preload="none").
import { useRef, useState } from 'react'
import { Play } from './Icons'
import { PhoneMock } from './ProductMock'
import { useT } from '../../lib/i18n'

const PUB = process.env.PUBLIC_URL || ''

export default function Film () {
  const h = useT().hero
  const ref = useRef(null)
  const [on, setOn] = useState(false)

  function play () {
    setOn(true)
    requestAnimationFrame(() => { ref.current?.play?.().catch(() => {}) })
  }

  return (
    <figure className={`lp-film${on ? ' is-on' : ''}`}>
      <div className="lp-film__glass">
        <div className="lp-film__screen">
          {on ? (
            <video
              ref={ref}
              src={`${PUB}/media/vsl.mp4`}
              controls
              playsInline
              autoPlay
            />
          ) : (
            <button type="button" className="lp-film__cover" onClick={play} aria-label={h.watch}
              style={{ '--sky': `url(${PUB}/media/hero-sky-m.jpg)` }}>
              <span className="lp-film__bg" aria-hidden="true" />
              <span className="lp-film__ph lp-film__ph--l" aria-hidden="true"><PhoneMock /></span>
              <span className="lp-film__ph lp-film__ph--c" aria-hidden="true"><PhoneMock /></span>
              <span className="lp-film__ph lp-film__ph--r" aria-hidden="true"><PhoneMock /></span>
              <span className="lp-film__cta">
                <span className="lp-film__btn"><Play /></span>
                <span className="lp-film__lab">{h.watchShort}</span>
              </span>
            </button>
          )}
        </div>
      </div>
    </figure>
  )
}
